/*
 * Copyright (c) Secureroo PTY LTD 2022
 */
export async function downloadFromSDK(firebaseConfig, storageRef, action, selector, fileName, path) {
  let bucket = import.meta.env.VITE_storageBucket;
  storageRef.child(path).getDownloadURL()
  .then((url) => {
    let query = url.substring(1);
    let vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) === 'token') {
        let token = decodeURIComponent(pair[1]);
        let removedDoubleSlash = path.replace("/customers/", "customers/");
        console.log(removedDoubleSlash)
        let newUrl = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodeURIComponent(
          removedDoubleSlash
        )}?alt=media&token=${token}`;
        let xhr = new XMLHttpRequest();
        xhr.open('GET', newUrl);
        xhr.responseType = 'blob';

        xhr.onload = event => {
          let blob = event.currentTarget.response;

          newUrl = window.URL.createObjectURL(blob);
          console.log(newUrl)
          if (action === 'download') {
            let a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.id = "magicDL";
            a.href = newUrl;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(newUrl);
            a.remove();
          } else if (action === 'display') {
            document.querySelector(selector).setAttribute('src', newUrl);
          }
        };

        xhr.send();

        return xhr;
      }
    }
    console.log('Query variable %s not found', 'token');
  })
  .catch((error) => {
    console.log(error);
    if (selector === '#companyImg') {
      if (error.code === 'storage/object-not-found') {
        let logoImgNumber = getRandomInt(6);
        storageRef.child(`templates/defaults/default_logos/default_tenancy_logo_${logoImgNumber}.png`).getDownloadURL()
          .then((url) => {
            let query = url.substring(1);
            let vars = query.split('&');
            for (let i = 0; i < vars.length; i++) {
              let pair = vars[i].split('=');
              if (decodeURIComponent(pair[0]) === 'token') {
                let token = decodeURIComponent(pair[1]);
                let newUrl = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodeURIComponent(
                  `templates/defaults/default_logos/default_tenancy_logo_${logoImgNumber}.png`
                )}?alt=media&token=${token}`;
                let xhr = new XMLHttpRequest();
                xhr.open('GET', newUrl);
                xhr.responseType = 'blob';

                xhr.onload = event => {
                  let blob = event.currentTarget.response;

                  newUrl = window.URL.createObjectURL(blob);
                  console.log(newUrl)
                  if (action === 'download') {
                    let a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.id = "magicDL";
                    a.href = newUrl;
                    a.download = fileName;
                    a.click();
                    window.URL.revokeObjectURL(newUrl);
                    a.remove();
                  } else if (action === 'display') {
                    document.querySelector(selector).setAttribute('src', newUrl);
                  }
                };

                xhr.send();

                return xhr;
              }
            }
            console.log('Query variable %s not found', 'token');
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  });
}

function getRandomInt(max) {
  return Math.floor(Math.random() * (Math.floor(max) - Math.ceil(1)) + Math.ceil(1));
}

// console.log(downloadFromSDK(firebaseConfig, storageRef, 'display', '#companyImg', 'different_file_name.png', 'logos/logo_test.png', false));
/*
  This is a function that will download a file from the firebase storage bucket.
  It takes in the following parameters:
  action: 'download' or 'display'
  selector: the selector of the element to display the image in
  fileName: the name of the file to download
  path: the path to the file in the storage bucket
  isExample: a boolean that determines if the function should use the example file or not

  The function will return the url of the file if the action is 'display' and the selector is not null.

  Example:
  Display an Image:
  let imgURL = downloadFromSDK(firebaseConfig, storageRef, 
    'display',
    '#companyImg',
    'companyLogo.png',
    'companyLogos/companyName/logo.png',
    false
  );
  document.getElementById('companyImg').src = imgURL;

  Download a File:
  downloadFromSDK(firebaseConfig, storageRef, 
    'download',
    null,
    'user_reports.csv',
    'companyReports/companyName/user_reports.csv',
    false
  );
*/

// Global Fixes for all pages

export function getCompanyImg(firebaseConfig, storageRef) {
  downloadFromSDK(firebaseConfig, storageRef, 'display',
    '#companyImg',
    companyID + '_logo.png',
    'companyLogos/' + companyID + '/' + companyID + '_logo.png');
}

export function getCompanyLogoImg() {
  downloadFromSDK(firebaseConfig, storageRef, 'display',
    '#companyLogoImg',
    companyID + '_logo.png',
    'companyLogos/' + companyID + '/' + companyID + '_logo.png');
}

// SUPPORTING DOCS REQUIRES THIS
